
import { ApiGroup } from "../types/ApiTypes"

/**
 * 사용자별 포인트 한도 정책 관련 API
 */
const UserPointLimitPolicyAPI: ApiGroup = {
    getUserPolicies: {
        title: "사용자 포인트 한도 정책 조회",
        url: "/PointLimitPolicy/User/:userSeqId",
        method: "GET",
        paramz: {},
        pathParams: ["userSeqId"],
    },
    assignUserPolicy: {
        title: "사용자 포인트 한도 정책 할당",
        url: "/PointLimitPolicy/User",
        method: "POST",
        paramz: {},
    },
    removeUserPolicy: {
        title: "사용자 포인트 한도 정책 할당 해제",
        url: "/PointLimitPolicy/User/:userSeqId/:policySeqId",
        method: "DELETE",
        paramz: {},
        pathParams: ["userSeqId", "policySeqId"],
    },
}

export default UserPointLimitPolicyAPI
